import scope from "@/constants/Scope";

const settings = {
    categoryName: "urlsearch",
    scope: scope,
  } as const;

  export default settings;